<template>
	<li class="task" v-bind:class="{overdue: isOverdue, today: isToday}">
		<span v-if="data.tasks[task] != undefined && data.tasks[task].tasks != undefined && data.tasks[task].tasks.length == 0" class="circle" v-on:click="complete" v-bind:class="{complete: completed != null}">
			<ErranditeIcon icon="check"/>
		</span>
		<span v-if="data.tasks[task] != undefined && data.tasks[task].tasks != undefined && data.tasks[task].tasks.length > 0" class="circle project" v-bind:style="{'background-color': data.tasks[task].colour}" v-on:click="state.breadcrumb.push(task)">
			<ErranditeIcon icon="folder"/>
		</span>
		<span v-if="data.tasks[task] == undefined || data.tasks[task].tasks == undefined" class="circle">
			
		</span>
		<span v-if="data.tasks[task] != undefined" v-on:click="state.breadcrumb.push(task)" class="label">
			<span>{{ label }}</span>
			<span v-if="data.tasks[task].tasks != undefined && data.tasks[task].tasks.length == 0" class="taskDateHolder">
				<span class="taskDate" v-if="data.tasks[task].end != null">
					<span v-if="data.tasks[task].start != null" class="taskDateObject">
						<ErranditeIcon icon="calendar-alt"/>
						<span>Start: {{ formattedDate(data.tasks[task].start) }}</span>
					</span>
					<span v-if="data.tasks[task].end != null" class="taskDateObject">
						<ErranditeIcon icon="calendar-alt"/>
						<span>Due: {{ formattedDate(data.tasks[task].end) }}</span>
					</span>
					<span v-if="data.tasks[task].end != null && data.tasks[task].time == true" class="taskDateObject">
						<ErranditeIcon icon="clock"/>
						<span>{{ formattedTime(data.tasks[task].end) }}</span>
					</span>
				</span>
				
			</span>
		</span>
		
	</li>
</template>

<script>

import ErranditeIcon from './ErranditeIcon.vue'
import { tasksCollection } from './firebase'
import dayjs from "dayjs";

export default {
	name: 'ErranditeTask',
	props: {
		task: String,
		state: Object,
		data: Object
	},
	computed: {
		label: function() {
			if (this.data.tasks[this.task] != undefined) {
				return this.data.tasks[this.task].label;
			} else {
				return "";
			}
		},
		completed: function() {
			if (this.data.tasks[this.task] != undefined) {
				return this.data.tasks[this.task].completed;
			} else {
				return null;
			}
		},
		isOverdue: function() {
			var now = new Date();
      
			var midnightToday = new Date();
			midnightToday.setHours(0,0,0,0);

			var midnightTonight = new Date();
			midnightTonight.setHours(24,0,0,0);

			if (this.data.tasks[this.task] != undefined && this.data.tasks[this.task].tasks != undefined && this.data.tasks[this.task].tasks.length == 0) {
				if (this.data.tasks[this.task].end < midnightToday || (this.data.tasks[this.task].end < now && this.data.tasks[this.task].time == true)) {
					return true;
				} else if (this.data.tasks[this.task].end < midnightTonight || this.data.tasks[this.task].start < midnightToday) {
					return false;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		isToday: function() {
			var now = new Date();
			
			var midnightToday = new Date();
			midnightToday.setHours(0,0,0,0);

			var midnightTonight = new Date();
			midnightTonight.setHours(24,0,0,0);
			
			if (this.data.tasks[this.task] != undefined && this.data.tasks[this.task].tasks != undefined && this.data.tasks[this.task].tasks.length == 0) {
				if (this.data.tasks[this.task].end < midnightToday || (this.data.tasks[this.task].end < now && this.data.tasks[this.task].time == true)) {
					return false;
				} else if (this.data.tasks[this.task].end < midnightTonight || this.data.tasks[this.task].start < midnightToday) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}
	},
	methods: {
		complete: function() {
			if (this.data.tasks[this.task] != undefined) {
				if (this.data.tasks[this.task].completed == null) {
					this.$set(this.data.tasks[this.task], "completed", new Date());
				} else {
					this.$set(this.data.tasks[this.task], "completed", null);
				}

				var docRef = tasksCollection.doc(this.task);
				docRef.set(this.data.tasks[this.task]).then(function() {
				console.log("Saved changes");
				});
			}
		},
		getTask: function(id) {
			var er = this;
			var docRef = tasksCollection.doc(id);
			er.$set(er.data.tasks, id, {});

			docRef.get().then(function(doc) {
					if (doc.exists) {
							console.log("Document data:", doc.data());
							var taskData = doc.data();
							if (taskData.start != null) {
								taskData.start = taskData.start.toDate();
							}
							if (taskData.end != null) {
								taskData.end = taskData.end.toDate();
							}
							er.$set(er.data.tasks, id, taskData);
					} else {
							// doc.data() will be undefined in this case
							console.log("No such document!");
					}
			}).catch(function(error) {
					console.log("Error getting document:", error);
			});
		},
		formattedDate: function(dt) {
			var day = dayjs(dt);
			var now = dayjs(new Date());

			var yesterday = new Date();
			yesterday.setDate(yesterday.getDate() - 1);
			var yest = dayjs(yesterday);

			var tomorrow = new Date();
			tomorrow.setDate(tomorrow.getDate() + 1);
			var tom = dayjs(tomorrow);

			var nextWeek = new Date();
			nextWeek.setDate(nextWeek.getDate() + 6);

			if (day.format("YYYY-MM-DD") == now.format("YYYY-MM-DD")) {
				return "Today";
			} else if (day.format("YYYY-MM-DD") == tom.format("YYYY-MM-DD")) {
				return "Tomorrow";
			} else if (day.format("YYYY-MM-DD") == yest.format("YYYY-MM-DD")) {
				return "Yesterday";
			} else if (dt.getTime() > new Date().getTime() && dt.getTime() < nextWeek.getTime()) {
				
				return day.format("dddd");
				} else {
				return day.format("ddd D MMM");
			}
		},
		formattedTime: function(dt) {
			var day = dayjs(dt);
			if (this.data.tasks[this.task].time == true) {
				return day.format("HH:mm");
			} else {
				return "";
			}
		}
	},
	mounted: function() {
		if (this.data.tasks[this.task] == undefined) {
			this.getTask(this.task);
		}
	},
	components: {
		ErranditeIcon
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";

li.task {
	display: flex;
	align-items: center;

	&.today {
		.taskDateHolder {
			color: $today;
		}
	}

	&.overdue {
		.taskDateHolder {
			color: $overdue;
		}
	}

	&:hover {
		background-color: $highlight;
		cursor: pointer;
	}

	border-bottom: 1px solid $dark2;

	

	.label {
		flex: 1 0 auto;
		padding: $padding $padding $padding $padding/4;

		.taskDateHolder {
			display: block;
			font-size: 10px;

			.taskDate {
				display: block;

				.taskDateObject {
					margin-right: $padding/2;
				}
			}

			.icon {
				margin-right: $padding/4;
			}
		}
	}

	

}

</style>
